import { Type } from "class-transformer";
import { ProjectDto } from "@/core/features/projects/project.dto";
import { UserDto } from "@/core/features/users/user.dto";
import { VehicleDto } from "@/core/features/vehicles/vehicle.dto";
import { PlanningBoardUserAssignmentDto } from "./planning-board-user-assignment.dto";

export class PlanningBoardProjectRowDto {
  id: string;

  projectId: string;

  @Type(() => ProjectDto)
  project: ProjectDto;

  notes?: string | null;

  @Type(() => UserDto)
  users: UserDto[];

  @Type(() => VehicleDto)
  vehicles: VehicleDto[];

  @Type(() => PlanningBoardUserAssignmentDto)
  userAssignments: PlanningBoardUserAssignmentDto[];

  isLocked: boolean;
}
